import { createResource, type RouteResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';

import type { RoutingRulesResponse } from '../../common/types';
import { getRoutingRules } from '../endpoints';

export const routingRulesResource: RouteResource<RoutingRulesResponse> = createResource({
	type: 'routingRulesResource',
	getKey: () => 'routingRulesResource',
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		assert(
			!!teamId,
			new AssertionError('routingRulesResource', 'teamId should be set to fetch routing-rules'),
		);

		return getRoutingRules(teamId);
	},
	isBrowserOnly: true,
});

export type { RoutingRulesResponse } from '../../common/types';
